import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { WhatInsideSection } from '../components/sales/WhatInsideSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalCtaSection } from '../components/sales/FinalCtaSection';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen" data-id="element-338">
      <HeroSection data-id="element-339" />
      <PainSection data-id="element-340" />
      <SolutionSection data-id="element-341" />
      <BenefitsSection data-id="element-342" />
      <WhatInsideSection data-id="element-343" />
      <TestimonialsSection data-id="element-344" />
      <FaqSection data-id="element-345" />
      <FinalCtaSection data-id="element-346" />
      <Footer data-id="element-347" />
    </main>;
}